import { CalculCodeStateKeys } from '@batical/types/src'
import { NavigationType } from './NavigationType'

export function addCalculLink(fromKey: string, fromCalculCode: CalculCodeStateKeys, toCalculCode: CalculCodeStateKeys) {
  return {
    type: NavigationType.ADD_CALCUL_LINK,
    payload: {
      fromKey,
      fromCalculCode,
      toCalculCode
    }
  }
}

export function clear() {
  return {
    type: NavigationType.CLEAR_CALCUL_LINK
  }
}

export function removeCalculLink(fromKey: string) {
  return {
    type: NavigationType.REMOVE_CALCUL_LINK,
    payload: {
      fromKey
    }
  }
}
